<template>
  <div class="pc-container">
    <!-- ===== 顶部导航 ===== 整合搜索、筛选、新建 -->
    <el-header class="header" style="height:75px;">
      <div class="header-left">
        <!-- 搜索框（按合同名称/编号） -->
        <el-input
          v-model="searchKeyword"
          placeholder="请输入合同名称或编号"
          size="medium"
          clearable
          @clear="handleSearch"
          @keyup.enter.native="handleSearch"
          class="search-input"
        />
        <el-select v-model="filterStatus" placeholder="合同状态" clearable size="medium" style="width:140px;">
          <el-option label="全部" value="" />
          <el-option label="执行中合同" value="valid" />
          <el-option label="历史合同" value="expired" />
          <!-- <el-option label="草稿" value="草稿" /> -->
        </el-select>
        <el-button type="primary" size="medium" @click="handleSearch">搜索</el-button>
      </div>
      <div class="header-right">
        <!-- <el-select v-model="filterStatus" placeholder="合同状态" clearable size="medium" style="width:140px;">
          <el-option label="全部" value="" />
          <el-option label="有效" value="有效" />
          <el-option label="过期" value="过期" />
          <el-option label="草稿" value="草稿" />
        </el-select> -->
        <!-- <el-button type="success" size="medium" @click="openAddDialog">
          <i class="el-icon-plus" /> 新建合同
        </el-button> -->
      </div>
    </el-header>

    <!-- ===== 主体 ===== 表格 + 分页 -->
    <el-main class="main-content">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <i class="el-icon-loading" /> 加载中...
      </div>

      <!-- 空状态 -->
      <div v-else-if="!contractList || contractList.length === 0" class="empty-state">
        <i class="el-icon-document" />
        <p>暂无合同数据</p>
      </div>

      <!-- 表格 -->
      <template v-else>
        <el-table
          :data="contractList"
          border
          stripe
          height="68vh"
          style="width:100%;"
          @row-click="showDetail"
        >
          <el-table-column prop="ht_code" label="合同编号" min-width="180" show-overflow-tooltip />
          <el-table-column prop="comlist_v1" label="合同名称" min-width="140" show-overflow-tooltip />
          <el-table-column prop="comlist_v2_1" label="甲方公司" min-width="160" show-overflow-tooltip />
          <el-table-column prop="comlist_v3_1" label="乙方公司" min-width="160" show-overflow-tooltip />
          <el-table-column prop="comlist_f1" label="合同金额" width="120" align="center">
            <template slot-scope="scope">
              ¥{{ scope.row.comlist_f1 || '0.00' }}
            </template>
          </el-table-column>
          <el-table-column prop="comlist_d1" label="签订日期" width="140" />
          <el-table-column prop="comlist_d3" label="有效期止" width="140" />
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getStatusType(scope.row)" size="small">
                {{ getStatusText(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="附件" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.attachment_url"
                type="text"
                size="mini"
                @click.stop="downloadAttachment(scope.row)"
              >
                下载
              </el-button>
              <span v-else style="color:#ccc;">无</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" align="center" fixed="right">
            <template slot-scope="scope">
              <!-- <el-button size="mini" type="primary" @click.stop="editContract(scope.row)">编辑</el-button> -->
              <el-button size="mini" type="danger" @click.stop="deleteContract(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        />
      </template>
    </el-main>

    <!-- ===== 新建/编辑合同对话框 ===== -->
    <el-dialog
      :title="formMode === 'add' ? '新建合同' : '编辑合同'"
      :visible.sync="formDialogVisible"
      width="800px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form ref="contractForm" :model="formData" label-width="140px" size="small" :rules="formRules">
        <!-- 基本信息 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同名称" prop="comlist_v1">
              <el-input v-model="formData.comlist_v1" placeholder="请输入合同名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同编号" prop="ht_code">
              <el-input v-model="formData.ht_code" placeholder="请输入合同编号" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="订单号" prop="order_dh">
              <el-input v-model="formData.order_dh" placeholder="关联订单号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同性质" prop="comlist_v5">
              <el-input v-model="formData.comlist_v5" placeholder="如：采购合同、框架协议" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 甲方信息 -->
        <el-divider content-position="left">甲方信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="甲方公司名称" prop="comlist_v2_1">
              <el-input v-model="formData.comlist_v2_1" placeholder="甲方公司全称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税人识别号" prop="comlist_v2_2">
              <el-input v-model="formData.comlist_v2_2" placeholder="甲方税号" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 乙方信息 -->
        <el-divider content-position="left">乙方信息</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="乙方公司名称" prop="comlist_v3_1">
              <el-input v-model="formData.comlist_v3_1" placeholder="乙方公司全称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="纳税人识别号" prop="comlist_v3_2">
              <el-input v-model="formData.comlist_v3_2" placeholder="乙方税号" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 合同细节 -->
        <el-divider content-position="left">合同细节</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="签订地点" prop="comlist_v4">
              <el-input v-model="formData.comlist_v4" placeholder="签订地点" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="签订日期" prop="comlist_d1">
              <el-date-picker v-model="formData.comlist_d1" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="有效期起" prop="comlist_d2">
              <el-date-picker v-model="formData.comlist_d2" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="有效期止" prop="comlist_d3">
              <el-date-picker v-model="formData.comlist_d3" type="date" value-format="yyyy-MM-dd" placeholder="截止日期" style="width:100%;" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="合同金额" prop="comlist_f1">
              <el-input-number v-model="formData.comlist_f1" :precision="2" :min="0" placeholder="金额" style="width:100%;" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款方式" prop="comlist_v6">
              <el-input v-model="formData.comlist_v6" placeholder="如：银行转账" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="付款比例" prop="comlist_v7">
              <el-input v-model="formData.comlist_v7" placeholder="如：30%预付+70%尾款" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结算方式" prop="comlist_v11">
              <el-select v-model="formData.comlist_v11" placeholder="请选择" style="width:100%;">
                <el-option label="现款现货" value="现款现货" />
                <el-option label="预付款" value="预付款" />
                <el-option label="部分付款" value="部分付款" />
                <el-option label="货到付款" value="货到付款" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="交货方式" prop="comlist_v8">
              <el-input v-model="formData.comlist_v8" placeholder="如：物流配送" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="验收时限" prop="comlist_v9">
              <el-input v-model="formData.comlist_v9" placeholder="如：7个工作日" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="备货周期" prop="comlist_v10">
              <el-input v-model="formData.comlist_v10" placeholder="如：15天" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否开票" prop="comlist_v12">
              <el-radio-group v-model="formData.comlist_v12">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注" prop="comlist_v13">
          <el-input v-model="formData.comlist_v13" type="textarea" :rows="2" placeholder="其他备注信息" />
        </el-form-item>

        <!-- 附件上传 -->
        <el-form-item label="合同附件">
          <el-upload
            action="#"
            :auto-upload="false"
            :on-change="handleUploadAttachment"
            :file-list="fileList"
            :limit="1"
            :on-exceed="handleExceed"
          >
            <el-button size="small" type="primary">选择文件</el-button>
            <div slot="tip" class="el-upload__tip">仅支持 pdf, doc, docx, 大小不超过10MB</div>
          </el-upload>
          <div v-if="uploadedFileUrl" style="margin-top:8px;color:#67c23a;">
            已上传：<a :href="uploadedFileUrl" target="_blank">{{ uploadedFileName || '查看附件' }}</a>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="formDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitContract">提交</el-button>
      </span>
    </el-dialog>

    <!-- ===== 合同详情弹窗 ===== -->
    <el-dialog
      title="合同详情"
      :visible.sync="detailDialogVisible"
      width="750px"
      :close-on-click-modal="false"
      @closed="detailData = {}"
    >
      <div v-if="detailData && detailData.id">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="合同编号">{{ detailData.ht_code }}</el-descriptions-item>
          <el-descriptions-item label="合同名称">{{ detailData.comlist_v1 }}</el-descriptions-item>
          <el-descriptions-item label="订单号">{{ detailData.order_dh || '-' }}</el-descriptions-item>
          <el-descriptions-item label="合同性质">{{ detailData.comlist_v5 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="甲方公司">{{ detailData.comlist_v2_1 }}</el-descriptions-item>
          <el-descriptions-item label="甲方税号">{{ detailData.comlist_v2_2 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="乙方公司">{{ detailData.comlist_v3_1 }}</el-descriptions-item>
          <el-descriptions-item label="乙方税号">{{ detailData.comlist_v3_2 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="签订地点">{{ detailData.comlist_v4 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="签订日期">{{ detailData.comlist_d1 }}</el-descriptions-item>
          <el-descriptions-item label="有效期起">{{ detailData.comlist_d2 }}</el-descriptions-item>
          <el-descriptions-item label="有效期止">{{ detailData.comlist_d3 }}</el-descriptions-item>
          <el-descriptions-item label="合同金额">¥{{ detailData.comlist_f1 || '0.00' }}</el-descriptions-item>
          <el-descriptions-item label="付款方式">{{ detailData.comlist_v6 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="付款比例">{{ detailData.comlist_v7 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="结算方式">{{ detailData.comlist_v11 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="交货方式">{{ detailData.comlist_v8 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="验收时限">{{ detailData.comlist_v9 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="备货周期">{{ detailData.comlist_v10 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="是否开票">{{ detailData.comlist_v12 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="2">{{ detailData.comlist_v13 || '-' }}</el-descriptions-item>
          <el-descriptions-item label="附件" :span="2">
            <a v-if="detailData.attachment_url" :href="detailData.attachment_url" target="_blank">下载附件</a>
            <span v-else>无</span>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer">
        <el-button @click="detailDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import axios from 'axios'
export default {
  name: 'ContractList',
  data () {
    return {
      uploadLoading: false,
      // ---------- 列表数据 ----------
      loading: false,
      contractList: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,

      // ---------- 搜索 & 筛选 ----------
      searchKeyword: '',
      filterStatus: '',

      // ---------- 详情弹窗 ----------
      detailDialogVisible: false,
      detailData: {},

      // ---------- 新建/编辑 ----------
      formDialogVisible: false,
      formMode: 'add', // 'add' | 'edit'
      submitLoading: false,
      formData: {
        // 对应接口字段
        comlist_v1: '',
        ht_code: '',
        order_dh: '',
        comlist_v2_1: '',
        comlist_v2_2: '',
        comlist_v3_1: '',
        comlist_v3_2: '',
        comlist_v4: '',
        comlist_v5: '',
        comlist_v6: '',
        comlist_v7: '',
        comlist_v8: '',
        comlist_v9: '',
        comlist_v10: '',
        comlist_v11: '',
        comlist_v12: '否',
        comlist_v13: '',
        comlist_f1: 0,
        comlist_d1: '',
        comlist_d2: '',
        comlist_d3: '',
        // 额外存储附件信息
        attachment_url: '',
        original_name: '',
        brand_id: null, // 品牌方id
        comlist2: '', // 手机号
        user_name: '', // 采购方姓名（可选）
        fenlei: 1 // 品牌方合同固定为1
      },
      fileList: [], // 上传组件文件列表
      uploadedFileUrl: '', // 上传成功后的url
      uploadedFileName: '',
      formRules: {
        comlist_v1: [{ required: true, message: '请输入合同名称', trigger: 'blur' }],
        comlist_v2_1: [{ required: true, message: '请输入甲方公司名称', trigger: 'blur' }],
        comlist_v3_1: [{ required: true, message: '请输入乙方公司名称', trigger: 'blur' }],
        comlist_d1: [{ required: true, message: '请选择签订日期', trigger: 'change' }],
        comlist_d3: [{ required: true, message: '请选择有效期止', trigger: 'change' }]
      }
    }
  },
  mounted () {
    this.initBrandInfo()
    this.fetchContractList()
  },
  methods: {
    async handleUploadAttachment (file, fileList) {
      this.fileList = fileList
      this.uploadedFileUrl = ''
      this.uploadedFileName = ''

      const rawFile = file.raw
      if (!rawFile) return

      const formData = new FormData()
      formData.append('file', rawFile)
      formData.append('comlist2', localStorage.getItem('user_name') || '')
      formData.append('comlistToken', localStorage.getItem('token') || '')

      const uploadUrl = 'https://caixiao.lianglianyn.com/index/upload_caix_ht.php'

      this.uploadLoading = true
      try {
        const res = await axios.post(uploadUrl, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            comlistToken: localStorage.getItem('token') || ''
          }
        })
        if (res.data && (res.data.code === '0' || res.data.code === 0)) {
          const imgUrl = res.data.url || res.data.yasuo_url || ''
          const originalName = res.data.original_name || rawFile.name
          if (imgUrl) {
            this.uploadedFileUrl = imgUrl
            this.uploadedFileName = originalName
            this.$message.success('附件上传成功')
          } else {
            this.$message.error('上传失败：未获取到文件地址')
            this.fileList = []
          }
        } else {
          this.$message.error(res.data?.msg || '上传失败')
          this.fileList = []
        }
      } catch (error) {
        console.error('上传失败', error)
        this.$message.error('网络错误，请重试')
        this.fileList = []
      } finally {
        this.uploadLoading = false
      }
    },
    // ---------- 初始化品牌信息 ----------
    initBrandInfo () {
      // 从localStorage或vuex获取品牌方id和手机号（请根据实际存储调整）
      this.formData.brand_id = parseInt(localStorage.getItem('sh_id'))
      this.formData.comlist2 = localStorage.getItem('user_name')
      this.formData.user_name = localStorage.getItem('user_name')
    },

    // ---------- 获取合同列表 ----------
    async fetchContractList (keepPage = false) {
      if (!keepPage) this.currentPage = 1
      this.loading = true
      try {
        const params = {
          a: 'lists',
          comlist2: this.formData.comlist2,
          //   brand_id: this.formData.brand_id,
          user_id: localStorage.getItem('crm_id')

        }
        // 搜索关键词（若后端支持）
        if (this.searchKeyword) params.keyword = this.searchKeyword
        if (this.filterStatus) params.type = this.filterStatus

        const res = await request.post('/ht/ht_lists.php', params)
        if (res && res.code === '0') {
          const data = res.data || []
          // 前端分页（若接口未分页）
          this.totalItems = data.length
          const start = (this.currentPage - 1) * this.pageSize
          const end = start + this.pageSize
          this.contractList = data.slice(start, end)
        } else {
          this.$message.error(res.msg || '获取列表失败')
          this.contractList = []
          this.totalItems = 0
        }
      } catch (e) {
        console.error('获取合同列表失败', e)
        this.$message.error('网络异常')
      } finally {
        this.loading = false
      }
    },

    // ---------- 搜索 ----------
    handleSearch () {
      this.fetchContractList()
    },

    // ---------- 分页 ----------
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchContractList(true)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchContractList(true)
    },

    // ---------- 表格状态 ----------
    getStatusText (row) {
      const now = new Date()
      const end = new Date(row.comlist_d3)
      if (!row.comlist_d3) return '未知'
      return end < now ? '过期' : '有效'
    },
    getStatusType (row) {
      const status = this.getStatusText(row)
      if (status === '有效') return 'success'
      if (status === '过期') return 'danger'
      return 'info'
    },

    // ---------- 详情 ----------
    showDetail (row) {
      this.detailData = { ...row }
      this.detailDialogVisible = true
    },

    // ---------- 附件下载 ----------
    downloadAttachment (row) {
      if (row.attachment_url) {
        window.open(row.attachment_url, '_blank')
      } else {
        this.$message.warning('无附件')
      }
    },

    // ---------- 新建 / 编辑 ----------
    openAddDialog () {
      this.formMode = 'add'
      this.formDialogVisible = true
      // if (!this.formData.ht_code) {
      //   const now = new Date()
      //   const prefix = 'HT'
      //   const date = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0')
      //   const rand = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
      //   this.formData.ht_code = prefix + date + rand
      // }
    },
    editContract (row) {
      this.formMode = 'edit'
      // 回填数据
      this.formData = { ...row }
      // 若有附件回显
      if (row.attachment_url) {
        this.uploadedFileUrl = row.attachment_url
        this.uploadedFileName = row.original_name || '附件'
        this.fileList = [{ name: this.uploadedFileName, url: this.uploadedFileUrl }]
      } else {
        this.fileList = []
        this.uploadedFileUrl = ''
        this.uploadedFileName = ''
      }
      this.formDialogVisible = true
    },

    handleExceed () {
      this.$message.warning('最多只能上传一个文件')
    },

    // ---------- 提交合同 ----------
    submitContract () {
      this.$refs.contractForm.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          // 组装提交数据
          const payload = {
            a: 'add',
            fenlei: 1,
            comlist2: this.formData.comlist2,
            user_name: this.formData.user_name,
            brand_id: this.formData.brand_id,
            brand_name: this.formData.comlist2,
            ht_code: this.formData.ht_code,
            order_dh: this.formData.order_dh || '',
            comlist_v1: this.formData.comlist_v1,
            comlist_v2_1: this.formData.comlist_v2_1,
            comlist_v2_2: this.formData.comlist_v2_2 || '',
            comlist_v3_1: this.formData.comlist_v3_1,
            comlist_v3_2: this.formData.comlist_v3_2 || '',
            comlist_v4: this.formData.comlist_v4 || '',
            comlist_v5: this.formData.comlist_v5 || '',
            comlist_v6: this.formData.comlist_v6 || '',
            comlist_v7: this.formData.comlist_v7 || '',
            comlist_v8: this.formData.comlist_v8 || '',
            comlist_v9: this.formData.comlist_v9 || '',
            comlist_v10: this.formData.comlist_v10 || '',
            comlist_v11: this.formData.comlist_v11 || '',
            comlist_v12: this.formData.comlist_v12 || '否',
            comlist_v13: this.formData.comlist_v13 || '',
            comlist_f1: this.formData.comlist_f1 || 0,
            comlist_d1: this.formData.comlist_d1,
            comlist_d2: this.formData.comlist_d2 || '',
            comlist_d3: this.formData.comlist_d3,
            // 附加上传的附件信息
            attachment_url: this.uploadedFileUrl,
            original_name: this.uploadedFileName
          }
          const res = await request.post('/ht/ht_lists.php', payload)
          if (res && res.code === '0') {
            this.$message.success('合同创建成功')
            this.formDialogVisible = false
            this.fetchContractList()
          } else {
            this.$message.error(res.msg || '提交失败')
          }
        } catch (e) {
          console.error('提交合同失败', e)
          this.$message.error('网络异常')
        } finally {
          this.submitLoading = false
        }
      })
    },

    // ---------- 删除（预留，接口未提供） ----------
    // 删除合同
    deleteContract (row) {
      this.$confirm('确定要删除该合同吗？删除后不可恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          // 构造删除参数
          const payload = {
            a: 'del',
            ht_id: row.id,
            comlist2: this.formData.comlist2,
            brand_id: this.formData.brand_id
          }

          const res = await request.post('/ht/ht_lists.php', payload)
          if (res && res.code === '0') {
            this.$message.success('删除成功')
            // 刷新列表，保持当前页码
            this.fetchContractList(true)
          } else {
            this.$message.error(res.msg || '删除失败')
          }
        } catch (e) {
          console.error('删除合同失败', e)
          this.$message.error('网络异常，请稍后重试')
        }
      }).catch(() => {
        // 用户取消删除，不做任何操作
      })
    },

    // ---------- 重置表单 ----------
    resetForm () {
      this.$refs.contractForm && this.$refs.contractForm.resetFields()
      this.fileList = []
      this.uploadedFileUrl = ''
      this.uploadedFileName = ''
      // 保留brand_id等基本信息
      const brandId = this.formData.brand_id
      const mobile = this.formData.comlist2
      const userName = this.formData.user_name
      this.formData = {
        comlist_v1: '',
        ht_code: '',
        order_dh: '',
        comlist_v2_1: '',
        comlist_v2_2: '',
        comlist_v3_1: '',
        comlist_v3_2: '',
        comlist_v4: '',
        comlist_v5: '',
        comlist_v6: '',
        comlist_v7: '',
        comlist_v8: '',
        comlist_v9: '',
        comlist_v10: '',
        comlist_v11: '',
        comlist_v12: '否',
        comlist_v13: '',
        comlist_f1: 0,
        comlist_d1: '',
        comlist_d2: '',
        comlist_d3: '',
        attachment_url: '',
        original_name: '',
        brand_id: brandId,
        comlist2: mobile,
        user_name: userName,
        fenlei: 1
      }
      // 重新生成编号（仅新建时）
      if (this.formMode === 'add') {
        const now = new Date()
        const prefix = 'HT'
        const date = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0')
        const rand = Math.floor(Math.random() * 1000000).toString().padStart(6, '0')
        this.formData.ht_code = prefix + date + rand
      }
    }
  }
}
</script>

<style scoped>
/* 与原有商品库页面保持一致，直接复用其样式 */
.pc-container {
  padding: 0 20px;
  box-sizing: border-box;
  /* display: flex;
  flex-direction: column; */
  height:85vh;
  overflow: auto;
  background-color: #f0f2f5;
  border-radius: 12px;
}
.header {
  background-color: #ffffff;
  border-bottom: 1px solid #e8ecf1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  flex-wrap: wrap;
  gap: 8px 12px;
}
.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.search-input {
  width: 260px;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.main-content {
  flex: 1;
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.loading-container,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  background: #fafbfc;
  border-radius: 8px;
}
.loading-container .el-icon-loading {
  font-size: 40px;
  color: #409eff;
  margin-bottom: 12px;
}
.empty-state i {
  font-size: 56px;
  color: #c0c4cc;
  margin-bottom: 12px;
}
.pagination {
  flex-shrink: 0;
  text-align: right;
  background: #ffffff;
  padding: 12px 16px;
  border-radius: 8px;
}
.el-table .el-table__row {
  cursor: pointer;
}
.el-divider {
  margin: 16px 0;
}
</style>
